module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg-image"
  }, [_c('img', {
    staticClass: "blured-image",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "src": _vm.imageSrc,
      "alt": _vm.alt
    }
  })]), _vm._v(" "), (_vm.showContactSales) ? _c('div', {
    staticClass: "bg-text"
  }, [_c('contact-sales')], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a50ed80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/BlurredImagePlaceHolder.vue
// module id = 3228
// module chunks = 3